import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const ShuttleBookingProperties: IProperty[] = [
    { id: Property.CancelPageLink, name: 'Navigate To on Bookings', type: PropertyType.PageLink },
    { id: Property.SuccessPage, name: 'Success Page', type: PropertyType.PageLink },
    { id: Property.FailedPage, name: 'Failed Page', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.BookingStatus, name: 'booking status', type: PropertyType.Number },
    { id: Property.LatestRecord, name: 'latest record', type: PropertyType.Boolean },
    { id: Property.PaymentEnable, name: 'Enable Payment', type: PropertyType.Boolean },
    { id: Property.PaymentDone, name: 'Payment Done', type: PropertyType.Boolean },
    { id: Property.EnableRefetch, name: 'Enable Refetch', type: PropertyType.Boolean },
    { id: Property.EnableTimer, name: 'Enable Timer', type: PropertyType.Boolean },
    { id: Property.EnableDownload, name: 'Enable Download', type: PropertyType.Boolean },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
    { id: Property.ShuttleStatus, name: 'Shuttle Status', type: PropertyType.String },

]
